import { useHistory } from 'react-router-dom';

export default function useShowDialogMessage() {
  const history = useHistory();
  return id => history.push(history.location.pathname, { dialogMessage: id });
}
